import styled from "styled-components"

import { ReactComponent as IconInfo } from "assets/svg/icon-info-message.svg"

const InfoBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #fff;
  border-radius: 8px;
  margin-bottom: 16px;
`

const InfoBannerText = styled.span`
  font-size: 14px;
  color: #334155;
  line-height: 1.510
  flex: 1;
`

const InfoIconWrapper = styled.span`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 20px;
    height: 20px;
  }
`

const IntelligenceReportsInfoBanner = () => (
  <InfoBanner>
    <InfoIconWrapper>
      <IconInfo />
    </InfoIconWrapper>
    <InfoBannerText>
      Intelligence Report is powered by Nuve AI and is currently in beta as we continue improving it. Results may
      occasionally vary, so we recommend reviewing outputs for accuracy.
    </InfoBannerText>
  </InfoBanner>
)

export default IntelligenceReportsInfoBanner
